/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Uebungsleiterproik4Inputs */

const de__field_uebungsleiterproik4 = /** @type {(inputs: _Field_Uebungsleiterproik4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungsleitungen pro Intensivkurs`)
};

/**

* @param {_Field_Uebungsleiterproik4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_uebungsleiterproik4 = /** @type {((inputs?: _Field_Uebungsleiterproik4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Uebungsleiterproik4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_uebungsleiterproik4(inputs)
});
export { _field_uebungsleiterproik4 as "_field_uebungsLeiterProIK" }